
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getSetCalculationitemsDeliveredDtoFormGroup() {
return new FormGroup({
    calculationitemIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    stocklocationId: new FormControl<number | undefined>(undefined, [Validators.required]),
    deliveredAt: new FormControl<string | undefined>(undefined),
})
;
}
      